import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import styles from '../styles'
import SectionHeader from './SectionHeader'
import CourseCard from 'src/components/course-card'
import { CoreButton } from 'src/components/core'
import useTrackerFunction from 'src/hooks/useTrackerFunction'

const CourseSection = ({ classes, courses, collection, isMobile }) => {
  const history = useHistory()
  const recentCourses = courses?.slice(0, 3) || []

  // Tracking functions
  const trackMoreCourses = useTrackerFunction('clicked_more_courses', {
    source: 'home_section',
    collection_id: collection?.id,
  })
  const trackCreateCourse = useTrackerFunction('clicked_create_course', {
    type: 'independent',
    source: 'home_section',
    collection_id: collection?.id,
  })
  const trackCourseClick = useTrackerFunction('clicked_course_card', {
    source: 'home_section',
    collection_id: collection?.id,
  })

  const handleMoreClick = () => {
    trackMoreCourses()
    history.push('/courses')
  }

  const handleCreateCourse = () => {
    trackCreateCourse()
    history.push('/create-course-selection/collectionId=undefined')
  }

  const handleCourseClick = course => {
    trackCourseClick({ course_id: course.id })
  }

  return (
    <Box className={classes.section}>
      <SectionHeader
        title="Recently created mini courses"
        link="/courses"
        linkText="More"
        onLinkClick={handleMoreClick}
      />

      {recentCourses.length === 0 ? (
        <Box className={classes.emptyState}>
          <Typography className={classes.emptyStateText}>
            Your first mini-course is waiting to be created. <br />
            <span className={classes.blueText}>Let's get started today!</span>
          </Typography>

          <CoreButton onClick={handleCreateCourse} fullWidth={isMobile}>
            Create mini course
          </CoreButton>
        </Box>
      ) : (
        <Box className={classes.coursesGrid}>
          {recentCourses.map(course => (
            <CourseCard
              key={course.id}
              course={course}
              courses={recentCourses}
              refresh={() => {}}
              open={false}
              setOpen={() => {}}
              onClick={() => handleCourseClick(course)}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default withStyles(styles)(CourseSection)
